import { apiClient } from './client';
import { PaginatedResponse } from '../types/pagination';
import { AdmissionsDashboard, AdmissionsStudentRow, ListAdmissionsParams } from '../types/admissions';

export const getAdmissionsDashboard = async (): Promise<AdmissionsDashboard> => {
  const { data } = await apiClient.get('/admissions/dashboard');
  return data.data;
};

export const listAdmissionsStudents = async (
  params: ListAdmissionsParams,
): Promise<PaginatedResponse<AdmissionsStudentRow>> => {
  const { data } = await apiClient.get('/admissions', { params });
  return data;
};
